<template>
  <div class='user-logo-container'>
    <img src="" alt="" v-if='imageLink'>
    <!-- <div class="sprite-image">
      <p class='sprite-text' :style='{color:randomColorGenerator()}'>{{ spriteText }}</p>
    </div> -->
    <p class='welcome-text'>Hello , </p>
    <p class='welcome-text'>{{ 'Pet Partner'|| spriteText }}</p>
  </div>
</template>

<script>
import { randomColour } from '../../Services/colours'
import { mapGetters } from 'vuex'
import * as NameSpace from '../../store/NameSpace'

export default {
  data () {
    return {
      username: '',
      spriteText: '',
      imageLink: null
    }
  },
  computed: {
    ...mapGetters({
      authState: NameSpace.AUTH_GETTER
    }),
    user () {
      return this.authState.auth
    }
  },
  created () {
    let name = this.user.name
    this.spriteText = name ? (name.charAt(0).toUpperCase() + name.slice(1)) : ''
  },
  methods: {
    randomColorGenerator () {
      let {r, g, b} = randomColour()
      return `rgb(${r},${g},${b})`
    }
  }
}
</script>

<style scoped>
  .sprite-image {
    border-radius: 50%;
    height: 3rem;
    width: 3rem;
    margin: 0 auto;
    position: relative;
    background-color: rgb(250, 250, 250);
  }
  .sprite-text {
    font-size: 0.5em;
    position: absolute;
    margin: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .user-logo-container {
    width: 12rem;
    position: absolute;
    right: 0;
  }
  .welcome-text {
    margin: 0.2rem 0;
    font-size: 1.1rem;
    color: white;
  }

  @media only screen and (min-width: 100px) {
    .user-logo-container {
      width: 12rem;
      position: static;
    }
  }

  @media only screen and (min-width: 1000px) {
    .user-logo-container {
      width: 12rem;
      position: absolute;
      right: 0;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Userlogo.vue?7594e486